function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChinaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4416",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4416)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33543 10.3165L2.41546 12.6051L3.53045 9.14409L1.58319 7.34445L4.2199 7.24714L5.33543 4.46132L6.45097 7.24714H9.08319L7.14041 9.14409L8.02544 12.6051L5.33543 10.3165Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2623 7.62891L10.037 8.36861L10.3164 6.92515L9.29608 5.84486L10.6777 5.78645L11.2623 4.43861L11.8468 5.78645H13.2261L12.2081 6.92515L12.5145 8.36861L11.2623 7.62891Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7623 10.6289L11.537 11.3686L11.8164 9.92515L10.7961 8.84486L12.1777 8.78645L12.7623 7.43861L13.3468 8.78645H14.7261L13.7081 9.92515L14.0145 11.3686L12.7623 10.6289Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2623 13.6289L10.037 14.3686L10.3164 12.9252L9.29608 11.8449L10.6777 11.7865L11.2623 10.4386L11.8468 11.7865H13.2261L12.2081 12.9252L12.5145 14.3686L11.2623 13.6289Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.26226 15.1289L7.03697 15.8686L7.31645 14.4252L6.29608 13.3449L7.67771 13.2865L8.26226 11.9386L8.8468 13.2865H10.2261L9.20807 14.4252L9.51455 15.8686L8.26226 15.1289Z",
      fill: "#FECA00"
    })]
  })]
}));
//# sourceMappingURL=China.js.map